import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import Header from 'pages/Destination/Header';
import TopAreas from 'pages/Destination/TopAreas';
import CoreValueProposition from 'pages/Destination/CoreValueProposition';
import DiscoverMore from 'pages/Destination/DiscoverMore';
import { getDestination } from 'store/destination/destinationSelectors';
import { PageBlockWhite, PageBlockPorcelain } from 'pages/Destination/Templates/primitives';

const StateTemplate = () => {
  const { discoverMoreAreas, regionName, subRegions } = useSelector(getDestination);

  return (
    <Fragment>
      <Header />
      <PageBlockPorcelain>
        <TopAreas areas={subRegions} title="Top areas" regionName={regionName} />
      </PageBlockPorcelain>
      <PageBlockWhite>
        <DiscoverMore areas={discoverMoreAreas} headingText="Discover more" />
      </PageBlockWhite>
      <PageBlockPorcelain>
        <CoreValueProposition />
      </PageBlockPorcelain>
    </Fragment>
  );
};

export default StateTemplate;
